import { useApi } from '@/api';
import {
  CurrencyValue,
  Flex,
  Heading,
  KpiSkeleton,
  Text,
  WalletAddress
} from '@blockanalitica/ui';
import { LinkButton } from '@/components';
import { Fragment } from 'react/jsx-runtime';

type DataResponse = {
  date: string;
  symbol: string;
  address: string;
  market_cap: string;
  market_cap_change: string;
  total_supply: string;
  total_supply_change: string;
  holders: number;
  holders_change: number;
  price: string;
  price_change: string;
  circulating_supply: string;
  circulating_supply_change: string;
};

export default function TokenInfo() {
  const [data, error] = useApi<DataResponse>({
    url: '/sparkstar/spk/token/'
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  return (
    <Fragment>
      <Heading size="4" paddingBottom="xs">
        Token Information
      </Heading>

      <Flex flexDirection="row" gap="s" justifyContent="space-between">
        <Text>Symbol:</Text>
        <Flex flexDirection="row" gap="xs">
          <Text color="muted">(Spark)</Text>
          {data.symbol}
        </Flex>
      </Flex>
      <Flex flexDirection="row" gap="s<" justifyContent="space-between">
        <Text>Contract Address:</Text>
        <WalletAddress
          address={data.address}
          options={{ showBlockie: false, showEthScanLink: true, inline: true }}
        />
      </Flex>

      <Flex flexDirection="row" gap="s" justifyContent="space-between">
        <Text>Current Price:</Text>
        <CurrencyValue value={data.price} options={{ currency: 'USD' }} />
      </Flex>
      <Flex flexDirection="row" gap="s" justifyContent="space-between">
        <Text>Market Cap:</Text>
        <CurrencyValue value={data.market_cap} options={{ currency: 'USD' }} />
      </Flex>
      <Flex flexDirection="row" gap="s" justifyContent="space-between">
        <Text>FDV:</Text>
        <CurrencyValue
          value={Number(data.total_supply) * Number(data.price)}
          options={{ currency: 'USD' }}
        />
      </Flex>
      <Flex flexDirection="row" gap="s" justifyContent="space-between">
        <Text>Total Supply:</Text>
        <CurrencyValue value={data.total_supply} />
      </Flex>
      <Flex flexDirection="row" gap="s" justifyContent="space-between">
        <Text>Circulating Supply:</Text>
        <Text>
          <CurrencyValue value={data.circulating_supply} />
        </Text>
      </Flex>
      <Flex flexDirection="row" gap="s" justifyContent="space-between">
        <Text>Holders:</Text>
        <CurrencyValue value={data.holders} />
      </Flex>
      <Flex flexDirection="row" gap="s" justifyContent="center">
        <LinkButton to="token" variant="whiteAndUgly" fontSize="-1">
          View more
        </LinkButton>
      </Flex>
    </Fragment>
  );
}
